function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

  this.mql = window.matchMedia('(min-width: 990px)');


  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (this.mql.matches) {
      if (event.currentTarget.classList.contains('collapsible-summary')) {
        const accordionContent = event.currentTarget.closest('details').querySelector('.accordion__content').outerHTML;
        event.currentTarget.closest('.collapsible-content').querySelector('.collapsible-dashboard').innerHTML = '';
        event.currentTarget.closest('.collapsible-content').querySelector('.collapsible-dashboard').innerHTML = accordionContent;
        document.querySelectorAll('details').forEach((detail) => {
          detail.removeAttribute('open');
          detail.setAttribute('aria-expanded', false);
        })
      }
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));

  });

  if (this.mql.matches) {
    if (summary.classList.value.includes('collapsible-summary is-first')) {
      summary.click();
    }
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }


  onFocusOut(event) {
    setTimeout(() => {
      //if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    //detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'));
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.currentPage = 1;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    /*if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }*/
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  /*onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === 4;
    console.log(this.currentPage);
    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }*/
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantClick);
  }

  onVariantClick() {
  }
  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.fakeButton();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      
      document.querySelector('.product-form__radios-button.fake-button-responsive').classList.remove('hidden');
      document.querySelector('.product-form__radios-button.fake-button-responsive .text').classList.remove('hidden');
      document.querySelector('.product-form__radios-button.size-button .text').classList.remove('hidden');
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      
    } else {
      
      document.querySelector('.product-form__radios-button.fake-button-responsive .text').classList.add('hidden');
      document.querySelector('.product-form__radios-button.size-button .text').classList.add('hidden');
      document.querySelector('.product-form__radios-button.fake-button-responsive').classList.add('hidden');
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  fakeButton() {
    this.mql = window.matchMedia('(min-width: 750px)');
    
    if (this.mql.matches) {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        if (productForm.classList.value.includes('js-submit-choose')) productForm.classList.remove('js-submit-choose');
      });
      document.body.classList.remove('overflow-custom');
      document.querySelector('fake-button').classList.remove('open');
      document.querySelector('.product-form__radios.size-radios').classList.remove('open');
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    if (document.querySelector('#PopupModal-Locations')) {

      document.querySelector('.locations-popup-modal__opener').classList.remove('hidden');

      this.locationMadrid = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-store-madrid');
      }).join('');
      this.locationValencia = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-store-valencia');
      }).join('');
      this.locationBarcelona = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-store-barcelona');
      }).join('');
      this.locationZaragoza = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-store-zaragoza');
      }).join('');
      this.locationSevilla = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-store-sevilla');
      }).join('');

      if (this.locationMadrid == 'true') {
        document.querySelector('#PickUpMadrid').querySelector('.unavailability-icon').style.display = 'none';
        document.querySelector('#PickUpMadrid').querySelector('.availability-icon').style.display = 'inline-block';
      } else {
        document.querySelector('#PickUpMadrid').querySelector('.availability-icon').style.display = 'none';
        document.querySelector('#PickUpMadrid').querySelector('.unavailability-icon').style.display = 'inline-block';
      }
      
      if (this.locationValencia == 'true') {
        document.querySelector('#PickUpValencia').querySelector('.unavailability-icon').style.display = 'none';
        document.querySelector('#PickUpValencia').querySelector('.availability-icon').style.display = 'inline-block';
      } else {
        document.querySelector('#PickUpValencia').querySelector('.availability-icon').style.display = 'none';
        document.querySelector('#PickUpValencia').querySelector('.unavailability-icon').style.display = 'inline-block';
      }
      
      if (this.locationBarcelona == 'true') {
        document.querySelector('#PickUpBarcelona').querySelector('.unavailability-icon').style.display = 'none';
        document.querySelector('#PickUpBarcelona').querySelector('.availability-icon').style.display = 'inline-block';
      } else {
        document.querySelector('#PickUpBarcelona').querySelector('.availability-icon').style.display = 'none';
        document.querySelector('#PickUpBarcelona').querySelector('.unavailability-icon').style.display = 'inline-block';
      }

      if (this.locationZaragoza == 'true') {
        document.querySelector('#PickUpZaragoza').querySelector('.unavailability-icon').style.display = 'none';
        document.querySelector('#PickUpZaragoza').querySelector('.availability-icon').style.display = 'inline-block';
      } else {
        document.querySelector('#PickUpZaragoza').querySelector('.availability-icon').style.display = 'none';
        document.querySelector('#PickUpZaragoza').querySelector('.unavailability-icon').style.display = 'inline-block';
      }

      if (this.locationSevilla == 'true') {
        document.querySelector('#PickUpSevilla').querySelector('.unavailability-icon').style.display = 'none';
        document.querySelector('#PickUpSevilla').querySelector('.availability-icon').style.display = 'inline-block';
      } else {
        document.querySelector('#PickUpSevilla').querySelector('.availability-icon').style.display = 'none';
        document.querySelector('#PickUpSevilla').querySelector('.unavailability-icon').style.display = 'inline-block';
      }
      
      if (document.querySelector('.location-size')) {
        document.querySelector('.location-size-wrapper').classList.remove('hidden');
        if (this.options[1]) {
          document.querySelector('.location-size').innerHTML = this.options[1];
        } else {
          document.querySelector('.location-size').innerHTML = this.options[0];
        }
      }
    }

    if (document.querySelector('.product-form__radios-button.size-button')) {  
      if (this.options[1]) {
        document.querySelector('.product-form__radios-button.size-button .value').innerHTML = this.options[1];
      } else {
        document.querySelector('.product-form__radios-button.size-button .value').innerHTML = this.options[0];
      }
    }
    if (document.querySelector('.product-form__radios-button.fake-button-responsive')) {  
      if (this.options[1]) {
        document.querySelector('.product-form__radios-button.fake-button-responsive .value').innerHTML = this.options[1];
      } else {
        document.querySelector('.product-form__radios-button.fake-button-responsive .value').innerHTML = this.options[0];
      }
    }

    this.small = window.matchMedia('(max-width: 750px)');
    
    if (this.small.matches) {
      setTimeout(() => {
        console.log(this);
        this.form = this.closest('.product-form__wrapper-sticky').querySelector('product-form .form');
        if (!this.form.classList.contains('product-form-bundle')) {
          document.querySelector('.product-form__submit').click();
        }
        document.body.classList.remove('overflow-custom');
        if (document.querySelector('fake-button').classList.contains('open')) {
          document.querySelector('fake-button.open').classList.remove('open');
        }
        if (document.querySelector('.product-form__radios.size-radios').classList.contains('open')) {
          document.querySelector('.product-form__radios.size-radios.open').classList.remove('open');
        }
        document.querySelector('.product-form .form:not(.product-form-bundle)').classList.add('js-submit-choose');
      }, 1000);
    }
  }
  
}

customElements.define('variant-radios', VariantRadios);


class ButtonRadios extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.toggleDropdown);

    const bgOverflow = document.querySelector('.product-form__radios.size-radios');

    document.addEventListener("click", (event) => {
      if (bgOverflow.classList.value.includes('open')) {

        if (bgOverflow !== event.target && !bgOverflow.contains(event.target) && event.target != document.querySelector('.product-form__radios-button.size-button')) {
          this.small = window.matchMedia('(max-width: 750px)');
    
          if (this.small.matches) {
            setTimeout(reinitSubmit, 1100); 
            function reinitSubmit() {
              document.body.classList.remove('overflow-custom');
              if (document.querySelector('fake-button').classList.contains('open')) {
                document.querySelector('fake-button.open').classList.remove('open');
              }
              if (document.querySelector('.product-form__radios.size-radios').classList.contains('open')) {
                document.querySelector('.product-form__radios.size-radios.open').classList.remove('open');
              }
              document.querySelector('.product-form .form:not(.product-form-bundle)').classList.add('js-submit-choose');
            }
          } else {
            document.body.classList.remove('overflow-custom');
            if (document.querySelector('fake-button').classList.contains('open')) {
              document.querySelector('fake-button.open').classList.remove('open');
            }
            if (document.querySelector('.product-form__radios.size-radios').classList.contains('open')) {
              document.querySelector('.product-form__radios.size-radios.open').classList.remove('open');
            }
            document.querySelector('.product-form .form').classList.remove('js-submit-choose');
          }
        }
        
      }
    });

  }
  toggleDropdown() {
    document.body.classList.toggle('overflow-custom');
    this.classList.toggle('open');
    this.nextElementSibling.classList.toggle('open');
  }

}

customElements.define('fake-button', ButtonRadios);

class ColorsSwitcher extends HTMLElement {
  constructor() {
    super();

    this.productColorsArray = Array.from(this.querySelectorAll('.product__color'));
    this.productColorsArray.forEach(link => link.addEventListener('click', this.linToColor.bind(this)));

  }

  linToColor(opener) {
    opener.preventDefault();

    [...opener.target.parentElement.children].forEach((sib) => sib.classList.remove("active"));
    opener.target.classList.add("active");

    
    fetch(opener.target.getAttribute('data-product-url') + '.js')
      .then((response) => response.json())
      .then((response) => {
        const product = this.closest('.card-wrapper');
        
        response.variants.forEach((variant) => {
          const inputSize = product.querySelector(`input[value="${variant.option2}"]`);
          if (variant.available == true) {
            if (inputSize) inputSize.removeAttribute("disabled")
          } else {
            if (inputSize) inputSize.setAttribute("disabled", true)
          }
          if (inputSize) inputSize.setAttribute("data-variant", variant.id);

        });

        /* IMAGES */ 
        const card__image1 = product.querySelector('.card__image-first');
        const card__image2 = product.querySelector('.card__image-second');

        if (card__image1 && response.images[0]) card__image1.srcset = response.images[0];
        if (card__image1 && response.images[0]) card__image1.src = response.images[0];
        if (card__image2 && response.images[1]) card__image2.srcset = response.images[1];
        if (card__image2 && response.images[1]) card__image2.src = response.images[1];

        /* COLOR */
        const card__color = product.querySelector('.card__color .value');
        if (card__color) card__color.innerHTML = response.options[0].values[0];

        /* PRICES */
        const card__priceWrapper = product.querySelector('.price');
        const card__price = product.querySelector('.price__regular .price-item.price-item--regular');
        const card__priceSale = product.querySelector('.price__sale .price-item.price-item--sale');
        const card__compPrice = product.querySelector('.price__sale .price-item.price-item--regular');

        if (response.compare_at_price == null || response.compare_at_price == 0) {
          if (card__priceWrapper) card__priceWrapper.classList.remove('price--on-sale');
          if (card__price) card__price.innerHTML = Shopify.formatMoney(response.price, '{{amount_with_comma_separator}} €');
        } else {
          if (card__priceWrapper) card__priceWrapper.classList.add('price--on-sale');
          if (card__priceSale) card__priceSale.innerHTML = Shopify.formatMoney(response.price, '{{amount_with_comma_separator}} €');
          if (card__compPrice) card__compPrice.innerHTML = Shopify.formatMoney(response.compare_at_price, '{{amount_with_comma_separator}} €');
        }

        /* URL */
        const card__url = product.querySelectorAll('a.card__link');
        if (card__url) {
          card__url.forEach((link) => {
            link.href = response.url
          })
        }

        /* WISHLIST */
        const card__whislist = product.querySelector('.wk-button');
        if (card__whislist) card__whislist.setAttribute("data-wk-add-product", response.id);

      })
      .finally(() => {
      });

      
  }

}

customElements.define('colors-switcher', ColorsSwitcher);

class CardQuickSizes extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.cardSizes = this.querySelector("fieldset");
    this.modalButton = this.querySelector(".modal-open-button");
    this.modalButton.addEventListener('click', this.toggleVariantModal.bind(this));
    this.modalBar = this.querySelector(".mobile-bar");
    this.modalBar.addEventListener('click', this.toggleVariantModal.bind(this));
    this.cardSizes.addEventListener('click', this.submitSize.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  submitSize(evt) {
    if (evt.target.tagName.toLowerCase() == "input" && !evt.target.hasAttribute("disabled")) {
      evt.preventDefault();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      if (document.body.classList.contains('template-cart')) {
        if (evt.target.getAttribute('data-presale')) {
          var addData = {
            'id': evt.target.getAttribute('data-variant'),
            'quantity': 1,
            'properties': {
              'Preventa': evt.target.getAttribute('data-presale')
            }
          }
        } else {
          var addData = {
            'id': evt.target.getAttribute('data-variant'),
            'quantity': 1
          }
        }
      } else {
        if (evt.target.getAttribute('data-presale')) {
          var addData = {
            'id': evt.target.getAttribute('data-variant'),
            'quantity': 1,
            'properties': {
              'Preventa': evt.target.getAttribute('data-presale')
            },
            'sections': this.cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
          }
        } else {
          var addData = {
            'id': evt.target.getAttribute('data-variant'),
            'quantity': 1,
            'sections': this.cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
          }
        }
      }
      
      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
        },
        method: 'POST'
      })
      .then((response) => response.json())
      .then((response) => {
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');   
        if (document.body.classList.contains('template-cart')) window.location.href = "/cart";
        this.container.classList.remove("visible");
      })

    }
    
  } 

  toggleVariantModal(evt) {
    evt.target.closest(".card__colors-switcher")?.classList.toggle("visible");
    if (this.container.classList.contains("visible")) {
      document.addEventListener('click', (evt) => {
        if (!this.cardSizes.contains(evt.target) && !this.modalButton.contains(evt.target)) {
          this.container.classList.remove("visible");
        }
      })
    }
  }

}

customElements.define('card-sizes', CardQuickSizes);

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', () => {

  if(window.location.pathname == "/pages/bimani") {
    const checkExist = setInterval(function() {
      const element = document.querySelector('.covet-pics-popup-show');
      const modal = element?.shadowRoot.querySelector('.popup-dialog');
      if (element) {
        const items = modal.querySelectorAll('.product');

        items.forEach((item) => {
          const buyLink = item.querySelector('.btn-buy');

          buyLink.classList.add('bimani_style_buy');
        });

        const goToIg = modal.querySelector('.source-link');

        goToIg.classList.add('bimani_style_gotoinstagram');

        clearInterval(checkExist);
      }
    }, 100);
  }

})


document.addEventListener('DOMContentLoaded', () => {

  if(window.location.href.includes('/products/')){

    // Define the target section you want to observe
    const complementaryProducts = document.getElementById('main-product-recommendations');
    const complementaryProductsShown = complementaryProducts.querySelector("product-recommendations");

    if(complementaryProducts) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            getListViewItems();
            observer.unobserve(complementaryProducts);
          }
        });
      });
  
      observer.observe(complementaryProducts);
    }

    function getListViewItems(isNext) {
      const slider = document.querySelector(".slider-complementary-products");

      if(slider != null) {
        const slides = slider.querySelectorAll(".complementary-slide");
      
        for (let i = 0; i < slides.length; i++) {
          const slide = slides[i];
          const ariaHidden = slide.getAttribute("aria-hidden");
          
          if (ariaHidden === "false") {
            let visibleItems = [];
            if(isNext != 'next') {
              visibleItems.push(slide);
            } 
    
    
            if (isNext === 'next') {
              const lastVisibleIndex = Math.min(i + 3, slides.length - 1);
              visibleItems.push(slides[lastVisibleIndex + 1]);
            } else {
              const numberOfSlides = isNext == 'next' ? 4 : 3;
              for (let j = 1; j <= numberOfSlides && i + j < slides.length; j++) {
                visibleItems.push(slides[i + j]);
              }
            }
      
            let slideViewItem = [];
            visibleItems.forEach((visibleItem) => {
    
              const index = visibleItem.closest('.complementary-slide');
    
              const productPrice = visibleItem.getAttribute('data-product-price');
    
              slideViewItem.push({
                  'item_id': visibleItem.getAttribute('data-product-id'),
                  'item_name': visibleItem.getAttribute('data-product-title').split(' - ')[0],
                  'currency': 'EUR',
                  'index': visibleItem.getAttribute('data-product-index'),
                  'item_category': visibleItem.getAttribute('data-product-category'),
                  'item_variant': visibleItem.getAttribute('data-product-variant'),
                  'price': parseFloat(visibleItem.getAttribute('data-product-price') / 100).toFixed(2),
                  'content_group': 'ecommerce',
                  'content_category': 'ecommerce',
              })
              
            });
    
            setTimeout(() => {
              dataLayer.push({ ecommerce: null });
              window.dataLayer.push({
                  'event': 'view_item_list',
                  ecommerce: {
                    'item_list_id': '',
                    'item_list_name': 'product_recommended',
                    items: [...slideViewItem]
                  }
              })
            }, 1000)
            
            break;
          }
        }
      }
    }

  }

})

function cardLink(event) {
  event.preventDefault();
    const currentURL = window.location.pathname;
    let page_type;
    let page_name = window.location.href;
    const segments = currentURL.split('/');
    if (segments.length >= 2) {
      page_type = segments[1];
    }
    if(currentURL == '/') {
        page_type = 'Home'
    }

    const slide = event.target.closest('.grid__item');
    const priceRegularElem = slide.querySelector('[data-old-price]');
    const priceEnd = (parseFloat(event.target.getAttribute('data-product-price')) / 100).toFixed(2);

    dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
          'event': 'select_item',
          ecommerce: {
            'item_list_id': event.target.getAttribute('data-product-index'),
            items: [
              {
                'item_id': event.target.getAttribute('data-product-id'),
                'item_name': event.target.getAttribute('data-product-title').split(' - ')[0],
                'currency': 'EUR',
                'index': event.target.closest('.card__link').getAttribute('data-product-index'),
                'item_category': event.target.getAttribute('data-product-category'),
                'item_variant': event.target.getAttribute('data-product-variant'),
                'price': (event.target.getAttribute('data-product-price') / 100).toFixed(2),
                'content_group': 'ecommerce',
                'content_category': event.target.getAttribute('data-product-content-category'),
              }
            ]
          }
      })
      setTimeout(() => {
        window.location.href = event.target.href;
      }, 1000)
}

if(window.location.href.includes('/collections')) {
  document.addEventListener('DOMContentLoaded', () => {

    const resultsContainer = document.querySelector('.product-grid');
    const allResults = resultsContainer?.querySelectorAll('.grid__item');
  
    let viewItems = [];
    allResults.forEach((item, index) => {
      
      let color = item.querySelector("a[data-product-color]")?.getAttribute('data-product-color');
      let storage = item.querySelector("a[data-product-storage]")?.getAttribute('data-product-storage');
      let condition = item.querySelector("a[data-product-condition]")?.getAttribute('data-product-condition');
  
      const variants = item.getAttribute('data-product-variant-title') ? item.getAttribute('data-product-variant-title') : item.getAttribute('data-product-title');
  
      const productPrice = item.getAttribute('data-product-price');
  
  
      const priceRegularElem = item.querySelector('[data-old-price]')?.getAttribute('data-old-price');
      const priceRegular = parseFloat(priceRegularElem / 100).toFixed(2);
      const priceEnd = (parseFloat(productPrice) / 100).toFixed(2);
  
      const discount = priceRegularElem - productPrice;
      const percentageDiscount = (discount / priceRegularElem) * 100;
      if (item.querySelector('[data-product-id]')?.getAttribute('data-product-id') != null) {
        viewItems.push({
          'item_id': item.querySelector('[data-product-id]')?.getAttribute('data-product-id'),
          'item_name': item.querySelector('[data-product-title]')?.getAttribute('data-product-title'),
          'currency': 'EUR',
          'index': item.querySelector('[data-product-index]')?.getAttribute('data-product-index'),
          'item_category': item.querySelector('[data-product-category]')?.getAttribute('data-product-category'),
          'item_variant': item.querySelector('[data-product-variant]')?.getAttribute('data-product-variant'),
          'price': parseFloat(item.querySelector('[data-product-price]')?.getAttribute('data-product-price') / 100).toFixed(2),
          'price_new': priceRegular,
          'discount': parseFloat(discount / 100).toFixed(2) > 0 ? parseFloat(discount / 100).toFixed(2) : "0",
          'item_brand': item.querySelector('[data-product-brand]')?.getAttribute('data-product-brand'),
          'discount_percentage': percentageDiscount.toFixed(2) == '-Infinity' ? '0' : percentageDiscount.toFixed(2),
          'content_group': 'ecommerce',
          'content_category': 'ecommerce',
          'color': color ? color : "",
          'condition': condition ? condition : "",
          'storage': storage ? storage : ""
        });
      }
    })
    setTimeout(() => {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        'event': 'view_item_list',
        ecommerce: {
          'item_list_id': '',
          'item_list_name': 'collection',
          items: [ ...viewItems ]
        }
      })
    }, 1000)
  
  
  })
}